import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class SupportWebsites extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			websites: [],
			ips: [],
			ip: '',
		};
		this.getWebsites = this.getWebsites.bind(this);
		this.updateWebsite = this.updateWebsite.bind(this);
		this.ipaddressAdd = this.ipaddressAdd.bind(this);
		this.ipaddressRemove = this.ipaddressRemove.bind(this);
	
	
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		this.getWebsites();

	}

	componentWillUnmount() {
	}


	async getWebsites() {
		let params = new URLSearchParams();
		const x = await postApi('/v3/support/websites', params);
		this.setState({status: true, websites: x.data.websites?x.data.websites:[], ips: x.data.ips?x.data.ips:[], ip: x.data.ip?x.data.ip:''});
	}

	async updateWebsite(website) {
		let params = new URLSearchParams();
		params.append('website', website);
		const x = await putApi('/v3/support/websites', params);
	}
	

	async ipaddressAdd() {
		let params = new URLSearchParams();
		params.append('ip', document.getElementById('ip').value);
		await putApi('/v3/support/ips', params);
		this.getWebsites();
	}


	async ipaddressRemove(id) {
		let params = new URLSearchParams();
		params.append('ip', id);
		await deleteApi('/v3/support/ips', params);
		this.getWebsites();
	}
	

	render() {

		const websites = this.state.websites.map((e,i) => {
			return (
				<div key={i} className="col my-1">
					<a href="#" onClick={()=>this.updateWebsite(e)} className="category-link font-weight-semibold">
						{e==='cloud'&&<svg xmlns="http://www.w3.org/2000/svg" className="category-svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M5 5h4v6H5zm10 8h4v6h-4zM5 17h4v2H5zM15 5h4v2h-4z" opacity=".3"></path><path d="M3 13h8V3H3v10zm2-8h4v6H5V5zm8 16h8V11h-8v10zm2-8h4v6h-4v-6zM13 3v6h8V3h-8zm6 4h-4V5h4v2zM3 21h8v-6H3v6zm2-4h4v2H5v-2z"></path></svg>}
						{e==='frontend'&&<svg xmlns="http://www.w3.org/2000/svg" className="category-svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"></rect></g><g><g opacity=".3"><path d="M6.71,18.71c-0.28,0.28-2.17,0.76-2.17,0.76s0.47-1.88,0.76-2.17C5.47,17.11,5.72,17,6,17c0.55,0,1,0.45,1,1 C7,18.28,6.89,18.53,6.71,18.71z M7.41,10.83L5.5,10.01l1.97-1.97l1.44,0.29C8.34,9.16,7.83,10.03,7.41,10.83z M13.99,18.5 l-0.82-1.91c0.8-0.42,1.67-0.93,2.49-1.5l0.29,1.44L13.99,18.5z M19.99,4.01c0,0-3.55-0.69-8.23,3.99 c-1.32,1.32-2.4,3.38-2.73,4.04l2.93,2.93c0.65-0.32,2.71-1.4,4.04-2.73C20.68,7.56,19.99,4.01,19.99,4.01z M15,11 c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C17,10.1,16.1,11,15,11z"></path></g><g><path d="M6,15c-0.83,0-1.58,0.34-2.12,0.88C2.7,17.06,2,22,2,22s4.94-0.7,6.12-1.88C8.66,19.58,9,18.83,9,18C9,16.34,7.66,15,6,15 z M6.71,18.71c-0.28,0.28-2.17,0.76-2.17,0.76s0.47-1.88,0.76-2.17C5.47,17.11,5.72,17,6,17c0.55,0,1,0.45,1,1 C7,18.28,6.89,18.53,6.71,18.71z M17.42,13.65L17.42,13.65c6.36-6.36,4.24-11.31,4.24-11.31s-4.95-2.12-11.31,4.24l-2.49-0.5 C7.21,5.95,6.53,6.16,6.05,6.63L2,10.69l5,2.14L11.17,17l2.14,5l4.05-4.05c0.47-0.47,0.68-1.15,0.55-1.81L17.42,13.65z M7.41,10.83L5.5,10.01l1.97-1.97l1.44,0.29C8.34,9.16,7.83,10.03,7.41,10.83z M13.99,18.5l-0.82-1.91 c0.8-0.42,1.67-0.93,2.49-1.5l0.29,1.44L13.99,18.5z M16,12.24c-1.32,1.32-3.38,2.4-4.04,2.73l-2.93-2.93 c0.32-0.65,1.4-2.71,2.73-4.04c4.68-4.68,8.23-3.99,8.23-3.99S20.68,7.56,16,12.24z M15,11c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2 S13.9,11,15,11z"></path></g></g></svg>}
						{e==='portal'&&<svg xmlns="http://www.w3.org/2000/svg" className="category-svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"></rect></g><g><g><path d="M4,18h16V8H4V18z M12,15h6v2h-6V15z M6.09,10.41L7.5,9l4,4l-4,4l-1.41-1.41L8.67,13L6.09,10.41z" opacity=".3"></path><rect height="2" width="6" x="12" y="15"></rect><path d="M20,4H4C2.89,4,2,4.9,2,6v12c0,1.1,0.89,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.11,4,20,4z M20,18H4V8h16V18z"></path><polygon points="7.5,17 11.5,13 7.5,9 6.09,10.41 8.67,13 6.09,15.59"></polygon></g></g></svg>}
						{e==='support'&&<svg xmlns="http://www.w3.org/2000/svg" className="category-svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24"><rect fill="none" height="24" width="24"></rect><g opacity=".3"><path d="M10,5h4v14h-4V5z M4,11h4v8H4V11z M20,19h-4v-6h4V19z"></path></g><g><path d="M16,11V3H8v6H2v12h20V11H16z M10,5h4v14h-4V5z M4,11h4v8H4V11z M20,19h-4v-6h4V19z"></path></g></svg>}
						{e==='template'&&<svg xmlns="http://www.w3.org/2000/svg" className="category-svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"></rect></g><g><g opacity=".3"><path d="M6.71,18.71c-0.28,0.28-2.17,0.76-2.17,0.76s0.47-1.88,0.76-2.17C5.47,17.11,5.72,17,6,17c0.55,0,1,0.45,1,1 C7,18.28,6.89,18.53,6.71,18.71z M7.41,10.83L5.5,10.01l1.97-1.97l1.44,0.29C8.34,9.16,7.83,10.03,7.41,10.83z M13.99,18.5 l-0.82-1.91c0.8-0.42,1.67-0.93,2.49-1.5l0.29,1.44L13.99,18.5z M19.99,4.01c0,0-3.55-0.69-8.23,3.99 c-1.32,1.32-2.4,3.38-2.73,4.04l2.93,2.93c0.65-0.32,2.71-1.4,4.04-2.73C20.68,7.56,19.99,4.01,19.99,4.01z M15,11 c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C17,10.1,16.1,11,15,11z"></path></g><g><path d="M6,15c-0.83,0-1.58,0.34-2.12,0.88C2.7,17.06,2,22,2,22s4.94-0.7,6.12-1.88C8.66,19.58,9,18.83,9,18C9,16.34,7.66,15,6,15 z M6.71,18.71c-0.28,0.28-2.17,0.76-2.17,0.76s0.47-1.88,0.76-2.17C5.47,17.11,5.72,17,6,17c0.55,0,1,0.45,1,1 C7,18.28,6.89,18.53,6.71,18.71z M17.42,13.65L17.42,13.65c6.36-6.36,4.24-11.31,4.24-11.31s-4.95-2.12-11.31,4.24l-2.49-0.5 C7.21,5.95,6.53,6.16,6.05,6.63L2,10.69l5,2.14L11.17,17l2.14,5l4.05-4.05c0.47-0.47,0.68-1.15,0.55-1.81L17.42,13.65z M7.41,10.83L5.5,10.01l1.97-1.97l1.44,0.29C8.34,9.16,7.83,10.03,7.41,10.83z M13.99,18.5l-0.82-1.91 c0.8-0.42,1.67-0.93,2.49-1.5l0.29,1.44L13.99,18.5z M16,12.24c-1.32,1.32-3.38,2.4-4.04,2.73l-2.93-2.93 c0.32-0.65,1.4-2.71,2.73-4.04c4.68-4.68,8.23-3.99,8.23-3.99S20.68,7.56,16,12.24z M15,11c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2 S13.9,11,15,11z"></path></g></g></svg>}
						<p className="fs-14 mb-0 text-center">{e}</p>
						<span className="fs-11 text-center d-block">https://{e}.ultrastream.io</span>
					</a>
				</div>
			)
		})

		const ips = this.state.ips.map((e,i) => {
			return (
				<tr key={i}>
					<td>
						<div className="d-flex align-items-center">
							<div className="me-2 lh-1">
								<span className="avatar avatar-sm">
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-1" />
								</span>
							</div>
							<div className="fs-14">{e.title?e.title:e.username}</div>
						</div>
					</td>
					<td>
						<span className="fw-semibold">{moment(new Date(e.mtime)).format("DD MMM YYYY h:mm A")}</span>
					</td>
					<td>
						{e.ip}
					</td>
					<td>
						<Button size="sm" onClick={()=>this.ipaddressRemove(e.id)}>Remove</Button>
					</td>
				</tr>
			)
		})
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										
										<div className="card custom-card overflow-hidden">
											<div className="card-header flex-between justify-content-between">
												<div className="card-title">Update Websites</div>
											</div>
											<div className="card-body">
												<div className="row">
													{websites}
													
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card custom-card">
											<div className="card-header justify-content-between">
											<div className="card-title">
														Order Summary
												</div>
												<div className="d-sm-flex">
													<div className="me-3 mb-2 mb-sm-0">
														<input className="form-control form-control-sm" type="text" placeholder="IP Address" aria-label=" example" id="ip" defaultValue={this.state.ip} />
													</div>
													<div className="dropdown">
														<Button size="sm" className="btn-wave waves-effect waves-light" onClick={this.ipaddressAdd}>
															Add IP<i className="ri-arrow-down-s-line align-middle ms-1 d-inline-block"></i>
														</Button>
													</div>
												</div>
											</div>
											<div className="card-body">
												<div className="table-responsive">
													<table className="table text-nowrap table-bordered">
														<thead>
															<tr>
																<th scope="col">Client</th>
																<th scope="col">Date</th>
																<th scope="col">IP Address</th>
																<th scope="col"></th>
															</tr>
														</thead>
														<tbody>
															{ips}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>
									
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
